(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@emotion/styled"));
	else if(typeof define === 'function' && define.amd)
		define("atomicLayout", ["react", "@emotion/styled"], factory);
	else if(typeof exports === 'object')
		exports["atomicLayout"] = factory(require("react"), require("@emotion/styled"));
	else
		root["atomicLayout"] = factory(root["react"], root["@emotion/styled"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__) {
return 